module.exports = __webpack_public_path__ + "img/chinesecompany56.6334f766.png";